import React from "react";
import styles from './ProfilePicture.module.scss';
import PropTypes from "prop-types";
import { getFirstLetter, getInitials } from "../../utils/stringUtils";

const ProfilePicture = ({
  profilePicture,
  firstName,
  lastName,
  size = "small",
}) => {
  const imageUrl = profilePicture ?? null;
  const initials = getInitials(firstName, lastName);
  const letter = getFirstLetter(firstName);
  return (
    <div className={`${styles.round} ${styles[`${letter}Letter`]} ${size && styles[size] ? styles[size] : ''}`}>
      { imageUrl ? (
        <img
          src={imageUrl}
          alt="Profile"
        />
      ) : <span>{initials}</span> }
    </div>
  );
}

ProfilePicture.propTypes = {
  profilePicture: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'xsm', 'small', 'sm', 'medium', 'large']),
}

export default ProfilePicture;